<section class="stc-ganadores-opt"
    style="background-image: url(/assets/images/sorteo2026/oportuno/banner-ganadores.jpg);">
    <div class="container">
        <div class="row">

          

            <div class="col-lg-7 offset-lg-5 my-auto text-center">
                <img src="/assets/images/sorteo2026/oportuno/logo.png" alt="Ganadores Primer Sorteo Oportuno 2026" width="400" class="img-fluid">
                <h1 style="color: #fff;">
                    CONOCE
                    <span class="text d-block" style="background-color: #712182;">
                        A NUESTROS GANADORES
                    </span>
                    
                    <span class="paragraph d-block">
                        1° SORTEO OPORTUNO
                    </span>
                </h1>
            </div>



        </div>
    </div>
</section>


<section class="stc-winners-opt anahuac">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <h2 style="background-color: #662380 !important;">
                    LISTA OFICIAL DE GANADORES
                    <span class="d-block">
                        1° SORTEO OPORTUNO 2026
                    </span>
                </h2>
            </div>
            <div class="col-md-12 ">
                <div class=" text-center" style="overflow-x: auto;">

                    <table class="table table-striped ">

                        <thead class="text-center">
                            <tr class="text-center">
                                <th class="border-none" colspan="4">Compradores</th>
                                <th class="border-none" colspan="3">Colaboradores</th>
                            </tr>
                            <tr class="text-center cols">
                                <th scope="col"><span>No. DE PREMIO</span></th>
                                <th scope="col"><span>nombre</span></th>
                                <th scope="col"><span>VALOR</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO</span></th>
                                <th scope="col"><span>NOMBRE</span></th>
                                <th scope="col"><span>VALOR</span></th>
                                <th scope="col"><span>NÚMERO DE BOLETO </span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="text-center first">
                                <td>1</td>
                                <td> Liliana S. M. C. </td>
                                <td> $250,000.00 </td>
                                <td>196052</td>
                                <td> Monserrat J. G. </td>
                                <td>$150,000.00</td>
                                <td>POR VENDER EL BOLETO 196052</td>
                            </tr>
                            <tr class="text-center second">
                                <td>2</td>
                                <td> Sofía B. B. </td>
                                <td> $200,000.00</td>
                                <td>117330</td>
                                <td> Sofía B. B. </td>
                                <td>$75,000.00</td>
                                <td>POR VENDER EL BOLETO 117330</td>
                            </tr>

                            <tr class="text-center first">
                                <td>3</td>
                                <td> Diego Antonio G. V. </td>
                                <td>$100,000.00</td>
                                <td>078497</td>
                                <td> Francisco Antonio N. G. </td>
                                <td>$30,000.00</td>
                                <td>POR VENDER EL BOLETO 078497</td>
                            </tr>

                            <tr class="text-center second">
                                <td>4</td>
                                <td>Ángel Gabriel L. M. </td>
                                <td>$50,000.00</td>
                                <td>097355</td>
                                <td> Elena Del Carmen L. G. </td>
                                <td>$20,000.00</td>
                                <td>POR VENDER EL BOLETO 097355</td>
                            </tr>

                            <tr class="text-center first">
                                <td>5</td>
                                <td> Laura Amalia C. C. </td>
                                <td>$25,000.00</td>
                                <td>417617</td>
                                <td> Marissa C. S. </td>
                                <td>$10,000.00</td>
                                <td>POR VENDER EL BOLETO 417617</td>
                            </tr>


                        </tbody>
                    </table>
                </div>
            </div>

            <div class="col-12">
                <p class="font-bold">
                    SORTEO ANÁHUAC MAGNO 2026
                </p>

                <p class="font-bold">
                   PRIMER SORTEO OPORTUNO
                </p>

                <p>
              El Sorteo Anáhuac celebró el viernes 22 de mayo de 2026, a las 11:15 horas, el Primer Sorteo Acumulado Especial para Compradores y Colaboradores Oportunos del Sorteo Anáhuac Magno en la Universidad Anáhuac México Campus Norte con domicilio en la Avenida Universidad Anáhuac no. 46 Col. Lomas Anáhuac. C.P. 52786 Huixquilucan, Estado de México con la presencia del <strong class="font-bold">Rubi Guadalupe Guerrero Garcia</strong>, Inspector de la Secretaría de Gobernación, para dar fe de la legalidad del evento. 
                </p>
                <p>
                    De acuerdo con lo establecido en el Permiso No. <strong class="font-bold">20260061PS09</strong> otorgado por la Secretaría de Gobernación a Sorteo Anáhuac, A.C., los resultados de los ganadores, así como los nombres de los colaboradores que se han hecho acreedores a un premio por haber vendido los boletos del premio uno al cinco, han de ser publicados de forma posterior al evento del sorteo en la página de internet https://www.sorteoanahuac.mx/ y nuestras redes sociales a partir del día 23 de mayo de 2026 y de acuerdo a lo registrado ante SEGOB, solo aparecerá el número ganador, el nombre propio de los ganadores, completándose con las iniciales de cada uno de los apellidos, adicionalmente, se publicará la lista con los nombres completos de los ganadores en las Instalaciones de la Universidad Anáhuac México Campus Norte, ubicada en la Av. Universidad no. 46 Colonia Lomas de Anáhuac, CP. 52786, Huixquilucan Estado de México. Los premios mayores a 1,500 (UMA) $175,965.00 (Ciento setenta y cinco mil novecientos sesenta y cinco pesos 00/100 m.n.) se solicitará la presencia de un inspector de la DGJS para la entrega de estos, conforme al siguiente calendario de fechas: 05 de junio de 2026 a las 12:00 horas Entrega del Premio 1 de Comprador del Primer Sorteo Acumulado Especial de Compradores y Colaboradores Oportunos del SORTEO ANAHUAC MAGNO. En las instalaciones de la Universidad Anáhuac México Campus Norte con domicilio en Av. Universidad Anáhuac no. 46 Huixquilucan, Estado de México. C.P. 52786.
                </p>
                
                <p>
                    Los premios serán pagados y entregados de conformidad con lo establecido en las bases de Sorteo , los premios menores a 1,500 (UMA) $175,965.00 (Ciento setenta y cinco mil novecientos sesenta y cinco pesos 00/100 m.n.) se realizará dentro de los 20 (veinte) días hábiles contados a partir de la celebración del sorteo, en Avenida Universidad Anáhuac N° 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México, piso 7 del edificio de Biblioteca, en horario de lunes a jueves de 10:00 a 18:00 hrs. y los viernes de 10:00 a 14:00 hrs. Para más información sobre dónde reclamar la entrega de los premios, documentos necesarios para recibirlos diríjase a: www.sorteoanahuac.mx, o a la oficina del Sorteo Anáhuac, A.C. ubicada en la calle “Av. Universidad Anáhuac no. 46, Col. Lomas Anáhuac, C.P. 52786, Huixquilucan, Estado de México o al teléfono: 01(55) 5328-8096 ext 2137.
                </p>

                <p>
                    Las personas que resulten ganadoras deberán presentar una identificación oficial vigente con fotografía (credencial INE, pasaporte), comprobante de domicilio (no mayor a tres meses) y CURP; el nombre completo escrito en el boleto debe corresponder exactamente con el del talón o con el registro en la APP del Sorteo Anáhuac y su identificación oficial.
En caso de queja derivada de este sorteo, la autoridad competente es la Dirección General de Juegos y Sorteos de la Secretaría de Gobernación ubicada en la calle de Versalles 49, piso 2, Col. Juárez, Del. Cuauhtémoc, C.P. 06600, Ciudad de México o bien comunicarse al teléfono: 01(55) 5209 8800.
                </p>

            </div>

        </div>
    </div>
</section>